let Table = require("./Table");
import * as Bootstrap from 'react-bootstrap';
import PanelWrapper from "./PanelWrapper";
import * as Tabs from "./Tabs";
import DropdownButton from "./DropdownButton";
import Dock from './Dock';
import Form from './Form';
import SearchList from './SearchList';
import CountBadge from './CountBadge';
import Loading from './Loading';

import './scss/custom.scss';

const UIComponents = {
	...Bootstrap,
	...Table,
  ...Tabs,
  Loading,
  DropdownButton,
  PanelWrapper,
  Dock,
  Form,
  SearchList,
  CountBadge,
}

export default UIComponents;



// WEBPACK FOOTER //
// ./src/components/UI/index.js